import React, { useMemo } from "react";
import { Route, Routes } from "react-router-dom";
import MenuPage from "../../Container/pages/MenuPage";
import { flattenMenus } from "../../../Utility/FlattenMenu";
import { useGetMenusDataQuery } from "../../../redux/services/internal/apiHome";

const MainMenuRoutes = ({ benchId }) => {
  const { data: fetchMenus = {} } = useGetMenusDataQuery(benchId, {
    refetchOnMountOrArgChange: true,
  });

  const transformedData = useMemo(() => {
    return fetchMenus.data ? flattenMenus(fetchMenus.data) : [];
  }, [fetchMenus.data]);

  return (
    <Routes>
      {transformedData?.map((item, index) => (
        <Route
          key={index}
          path={item.slug}
          element={<MenuPage benchId={benchId} />}
        />
      ))}
    </Routes>
  );
};

export default MainMenuRoutes;
